export default "__VITE_ASSET__547c31a1__"